import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { SearchBreadcrumbs, TrustpilotWidget } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { TEMPLATE_IDS } from '@spotahome/ui-library/src/tenant/components/TrustpilotWidget/TrustpilotWidget';

import SearchSEOTitle from '@spotahome/marketplace-common/src/components/SearchTitle/SearchSEOTitle';

import MapButton from '../components/MapButton';

import { useSeoCitiesContext } from '../context/SeoCitiesContext';

import { useSeoTotalSearchResults } from '../context/SeoSearchContext';

import SearchFilters from './SearchFilters';

import './Hero.scss';

const Hero = ({ title }) => {
  const { currentCity, propertyType, anchorText } = useSeoCitiesContext();
  const totalResults = useSeoTotalSearchResults();

  const [showMap, toggleShowMap] = useState(false);

  return (
    <section className="module-container">
      <main className="hero__main">
        <div>
          <header>
            <SearchBreadcrumbs
              cityName={currentCity.cityName}
              cityId={currentCity.id}
              countryId={currentCity.country.countryId}
              propertyType={[propertyType]}
              anchorText={anchorText}
            />
          </header>
          <div className="hero__main-content">
            <SearchSEOTitle
              size="medium"
              cityName={currentCity.cityName}
              totalResults={totalResults}
              seoTitle={title}
            />
            <p className="hero__subtitle">
              {trans('seo_metas.location.subtitle')}
            </p>
            <SearchFilters city={currentCity} />
          </div>
        </div>
        <aside className="hero__aside">
          <Fragment>
            <MapButton
              className="hero__aside-map"
              showMap={showMap}
              toggleShowMap={toggleShowMap}
            />
            {!showMap && (
              <TrustpilotWidget
                template={TEMPLATE_IDS.MICRO_TRUST_SCORE}
                height={24}
                className="hero__trustpilot--variant"
              />
            )}
          </Fragment>
        </aside>
      </main>
    </section>
  );
};

Hero.propTypes = {
  title: PropTypes.string.isRequired
};

export default Hero;
